<template>
  <div class="pt-8 flex flex-col items-start">
    <h1 class="text-2xl font-bold text-center mb-4">حضره الأن</h1>
    <div class="flex flex-wrap items-start">
      <div
        v-for="(order, index) in orders"
        :id="'id' + index"
        :key="order.number"
        class="xl:w-80 lg:w-72 md:w-80 sm:w-72 order-wrapper"
        @click="notifyOrderSelection(order, index)"
      >
        <div
          class="leading-relaxed cursor-pointer flex justify-between text-white px-3 py-1 rounded-xl"
          :class="{
            'bg-red-450': order.status == 'out-of-sla',
            'bg-green-450': order.status == 'in-sla',
          }"
        >
          <p class="textWrapper">
            <span class="font-bold block">{{ order?.kitchen_picker?.name }}</span>
            <span class="text-sm date"> {{ order.time }}</span>
            <span class="font-normal block">{{ order.customer_group !== 'Normal' ? order.customer_group : '' }}</span>
          </p>
          <p class="text-left">
            <span class="font-bold number block">{{ order.order_number }}</span>
            <span class="text-sm">{{ order.items.length }} منتجات</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineExpose } from 'vue';
const props = defineProps({
  orders: {
    type: Array,
    required: true,
  },
  currentOrderIndex: {
    type: Number,
    required: true,
  },
});
const currentId = ref('#id' + props.currentOrderIndex);
const previousId = ref(null);

const emit = defineEmits(['orderSelection']);

const notifyOrderSelection = (order, index) => {
  previousId.value = currentId.value;
  if (previousId.value) document.querySelector(previousId.value).classList.remove('selected-order-wrapper');
  currentId.value = '#id' + index;
  document.querySelector(currentId.value).classList.add('selected-order-wrapper');
  emit('orderSelection', { order: order, orderIndex: index });
};

const selectThePulledOrder = index => {
  setTimeout(() => {
    previousId.value = currentId.value;
    if (previousId.value) document.querySelector(previousId.value).classList.remove('selected-order-wrapper');
    currentId.value = '#id' + index;
    document.querySelector(currentId.value).classList.add('selected-order-wrapper');
  }, 1000);
};

defineExpose({
  selectThePulledOrder,
});
</script>

<style>
.order-wrapper {
  border: 5px solid #e5e5e5;
}

.selected-order-wrapper {
  border: 5px solid #84c559;
  border-radius: 20px;
}
.textWrapper {
  flex-grow: 1;
}
</style>
